<ng-container>
  <span class="description">
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.ADDED_TO_LIST.ADDED_TO_LIST' | translate }}
  </span>
  <automata-automation-replacement-chips
    label="AUTOMATIONS.COMMON.LIST"
    [dataService]="actionListsSelectorService"
    [formControl]="actionListNameControl"
    [isRequired]="true"
    [multiple]="false"
    [supportDataPassing]="false"
    (finishedInitialLoading)="finishedLoadingSelector()"
  ></automata-automation-replacement-chips>
</ng-container>
